function ifNullStringNull(value) {
  if (value == 'null') {
    return null;
  }
  return value;
}

export { ifNullStringNull };
